var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10.8387C3.58065 6.36774 7.47097 3 11.9419 3C16.9355 3 21 7.06452 21 12.0581C21 16.529 17.6323 20.4194 13.1613 21H13.1032C12.9871 21 12.871 20.9419 12.8129 20.8839C12.6968 20.7677 12.6387 20.6516 12.6387 20.5355V16.8774C12.6387 16.7032 12.8129 16.529 12.9871 16.471C15.0774 16.0065 16.529 14.2065 16.529 12.0581C16.529 9.50323 14.4387 7.47097 11.9419 7.47097C9.85161 7.47097 7.99355 8.92258 7.52903 11.0129C7.52903 11.2452 7.35484 11.3613 7.12258 11.3613H3.46452C3.34839 11.3613 3.17419 11.3032 3.11613 11.1871C3 11.071 3 10.9548 3 10.8387ZM7.52903 13.1032C7.87742 14.729 9.2129 16.0645 10.8968 16.471C11.129 16.529 11.2452 16.7032 11.2452 16.8774V20.5355C11.2452 20.6516 11.1871 20.8258 11.071 20.8839C11.0129 20.9419 10.8968 21 10.7806 21H10.7226C6.71613 20.4774 3.52258 17.2839 3 13.2774C3 13.1613 3.05806 13.0451 3.11613 12.929C3.23226 12.8129 3.34839 12.7548 3.46452 12.7548H7.12258C7.29677 12.7548 7.47097 12.929 7.52903 13.1032Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/Pie.d1ea654624ba7463acfa89fea4a92e0a.svg";
export { ForwardRef as ReactComponent };